const CHOOSE_SUBSCRIPTION = 'CHOOSE_SUBSCRIPTION';
const SET_RETURN_URL = 'SET_RETURN_URL';
const CHECKOUT_VISITED = 'CHECKOUT_STARTED';
const CHECKOUT_FINISHED = 'CHECKOUT_FINISHED';

export { CHOOSE_SUBSCRIPTION, SET_RETURN_URL, CHECKOUT_VISITED, CHECKOUT_FINISHED };